import type { Observable } from 'rxjs';

import type { MarketplaceLayout } from './types';

export abstract class LayoutSource {
  abstract getLayout(): Observable<MarketplaceLayout>;
}
